import TabPanel from "@/components/TabPanel/TabPanel";
import ClaimTabContent from "@/features/creditor/claimsTab/claimsTabContent";
import CreditorSummary from "./CreditiorSummary";
import CreditorSummaryHeader from "./CreditorSummaryHeader";
import CreditorAttributeHistoryTab from "../CreditorHistoryClaims/creditorAttributeHistory";
import { useParams } from "react-router-dom";
import { useCase } from "@/features/case/use-case";
import { useGetCreditorSummaryHeaderDataQuery } from "./CreditorSummaryReducer";
import { MotifProgressLoader } from "@ey-xd/motif-react";
import CreditorDistributions from "../CreditorDistributions";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setRetainCreditorId } from "@/features/retain_state/retainStateSlice";

export default function CreditorSummaryView() {
  const parameter = useParams();
  const caseData = useCase();

  const propData = {
    caseId: caseData.caseId,
    creditorId: parameter.creditorId || "",
  };
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setRetainCreditorId({ creditorId: parameter.creditorId }));
  }, [dispatch, parameter.creditorId]);
  const { data, isLoading, isFetching, refetch } =
    useGetCreditorSummaryHeaderDataQuery(propData);
  useEffect(() => {
    refetch();
  }, [refetch]);
  const tabPanelData = {
    title: [
      "pages.creditors.creditorView.tabPannelDetails.summary",
      "pages.creditors.creditorView.tabPannelDetails.claims",
      "pages.creditors.creditorView.tabPannelDetails.attributeHistory",
      "pages.creditors.creditorView.tabPannelDetails.distributions",
    ],
    content: [
      <CreditorSummary />,
      <ClaimTabContent creditorDetails={data} />,
      <CreditorAttributeHistoryTab />,
      <CreditorDistributions creditorDetails={data} />,
    ],
  };
  if (isLoading || isFetching) {
    return <MotifProgressLoader show variant="default" />;
  }
  return (
    <>
      <CreditorSummaryHeader
        caseId={propData.caseId}
        creditorId={propData.creditorId || ""}
        headerData={data}
      />
      <div className="ccwp_table_wrapper ccwp_table_dropdown_wrapper">
        <TabPanel data={tabPanelData} />
      </div>
    </>
  );
}
